import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";

export interface CustomerFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const CustomerFilter = ({
  value = [],
  onChange,
  t,
}: CustomerFilterProps) => {
  return (
    <ColorSearchAutocomplete
      label={t("filter_general_customer_name")}
      type="customerName"
      value={value}
      onChange={onChange}
    />
  );
};
